// Import all the JSON files so Parcel can handle them properly
import downloadedAnimationData from '../assets/lottie/downloaded_icon.json';
import playCTAAnimationData from '../assets/lottie/playCTA.json';
import myListCTAAnimationData from '../assets/lottie/myListCTA.json';
import favoriteCTAAnimationData from '../assets/lottie/favoriteCTA.json';
import playLGAnimationData from '../assets/lottie/play_lg.json';
import favoriteBookmarkAnimationData from '../assets/lottie/favoriteBookmark.json';
import successAnimationData from '../assets/lottie/success.json';
import spinnerAnimationData from '../assets/lottie/spinner.json';

// Animation objects
let animDownloaded, animPlayCTA, animMyListCTA, animFavoriteCTA, animPlayLG;
let animFavoriteBookmark, animSuccess, animSpinner;

// Initialize all animations
function initializeAnimations() {
    const downloadedElement = document.getElementById('downloaded');
    if (downloadedElement) {
        animDownloaded = bodymovin.loadAnimation({
            container: downloadedElement,
            renderer: 'svg',
            loop: false,
            autoplay: true,
            animationData: downloadedAnimationData
        });
    }

    const playCTAElement = document.getElementById('playCTA');
    if (playCTAElement) {
        animPlayCTA = bodymovin.loadAnimation({
            container: playCTAElement,
            renderer: 'svg',
            loop: false,
            autoplay: true,
            animationData: playCTAAnimationData
        });
    }

    const myListCTAElement = document.getElementById('myListCTA');
    if (myListCTAElement) {
        animMyListCTA = bodymovin.loadAnimation({
            container: myListCTAElement,
            renderer: 'svg',
            loop: false,
            autoplay: false,
            animationData: myListCTAAnimationData
        });
        animMyListCTA.addEventListener('DOMLoaded', function () {
            animMyListCTA.playSegments([[0, 46]], true);
        });
    }

    const favoriteCTAElement = document.getElementById('favoriteCTA');
    if (favoriteCTAElement) {
        animFavoriteCTA = bodymovin.loadAnimation({
            container: favoriteCTAElement,
            renderer: 'svg',
            loop: false,
            autoplay: false,
            animationData: favoriteCTAAnimationData
        });
        animFavoriteCTA.addEventListener('DOMLoaded', function () {
            animFavoriteCTA.playSegments([[0, 34]], true);
        });
    }

    const playLGElement = document.getElementById('playLG');
    if (playLGElement) {
        animPlayLG = bodymovin.loadAnimation({
            container: playLGElement,
            renderer: 'svg',
            loop: false,
            autoplay: true,
            animationData: playLGAnimationData
        });
    }

    const favoriteBookmarkElement = document.getElementById('favoriteBookmark');
    if (favoriteBookmarkElement) {
        animFavoriteBookmark = bodymovin.loadAnimation({
            container: favoriteBookmarkElement,
            renderer: 'svg',
            loop: false,
            autoplay: false,
            animationData: favoriteBookmarkAnimationData
        });
        animFavoriteBookmark.addEventListener('DOMLoaded', function () {
            animFavoriteBookmark.playSegments([[0, 26]], true);
        });
    }

    const successElement = document.getElementById('success');
    if (successElement) {
        animSuccess = bodymovin.loadAnimation({
            container: successElement,
            renderer: 'svg',
            loop: false,
            autoplay: true,
            animationData: successAnimationData
        });
    }

    const spinnerElement = document.getElementById('spinner');
    if (spinnerElement) {
        animSpinner = bodymovin.loadAnimation({
            container: spinnerElement,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData: spinnerAnimationData
        });
    }

}

// Initialize animations when DOM is ready
initializeAnimations();

// Refresh functions
function refreshDownloaded() {
    if (animDownloaded) {
        animDownloaded.goToAndPlay(0, true);
    }
}

function refreshPlayCTA() {
    if (animPlayCTA) {
        animPlayCTA.goToAndPlay(0, true);
    }
}

function refreshMyListCTA() {
    const element = document.querySelector('.myListCTA');
    if (element) {
        element.classList.remove('saved');
    }
    if (animMyListCTA) {
        animMyListCTA.playSegments([[0, 46]], true);
    }
}

function refreshFavoriteCTA() {
    const element = document.querySelector('.favoriteCTA');
    if (element) {
        element.classList.remove('saved');
    }
    if (animFavoriteCTA) {
        animFavoriteCTA.playSegments([[0, 34]], true);
    }
}

function refreshPlayLG() {
    if (animPlayLG) {
        animPlayLG.goToAndPlay(0, true);
    }
}

function refreshFavoriteBookmark() {
    const element = document.querySelector('.favoriteBookmark');
    if (element) {
        element.classList.remove('saved');
    }
    if (animFavoriteBookmark) {
        animFavoriteBookmark.playSegments([[0, 26]], true);
    }
}

function refreshSuccess() {
    if (animSuccess) {
        animSuccess.goToAndPlay(0, true);
    }
}

// Interactive functions
function myListToggle() {
    const element = document.querySelector('.myListCTA');
    if (element) {
        element.classList.toggle('saved');
        if (element.classList.contains('saved')) {
            if (animMyListCTA) animMyListCTA.playSegments([[46, 34]], true);
        } else {
            if (animMyListCTA) animMyListCTA.playSegments([[34, 46]], true);
        }
    }
}

function favoriteToggle() {
    const element = document.querySelector('.favoriteCTA');
    if (element) {
        element.classList.toggle('saved');
        if (element.classList.contains('saved')) {
            if (animFavoriteCTA) animFavoriteCTA.playSegments([[34, 46]], true);
        } else {
            if (animFavoriteCTA) animFavoriteCTA.playSegments([[46, 34]], true);
        }
    }
}

function bookmarkToggle() {
    const element = document.querySelector('.favoriteBookmark');
    if (element) {
        element.classList.toggle('saved');
        if (element.classList.contains('saved')) {
            if (animFavoriteBookmark) animFavoriteBookmark.playSegments([[26, 14]], true);
        } else {
            if (animFavoriteBookmark) animFavoriteBookmark.playSegments([[14, 26]], true);
        }
    }
}

// Event listeners - only add if elements exist
document.addEventListener('DOMContentLoaded', function() {
    const downloadedBtn = document.querySelector('.downloaded_btn');
    if (downloadedBtn) downloadedBtn.addEventListener('click', refreshDownloaded);

    const playCTABtn = document.querySelector('.playCTA_btn');
    if (playCTABtn) playCTABtn.addEventListener('click', refreshPlayCTA);

    const myListCTABtn = document.querySelector('.myListCTA_btn');
    if (myListCTABtn) myListCTABtn.addEventListener('click', refreshMyListCTA);

    const favoriteCTABtn = document.querySelector('.favoriteCTA_btn');
    if (favoriteCTABtn) favoriteCTABtn.addEventListener('click', refreshFavoriteCTA);

    const playLGBtn = document.querySelector('.playLG_btn');
    if (playLGBtn) playLGBtn.addEventListener('click', refreshPlayLG);

    const favoriteBookmarkBtn = document.querySelector('.favoriteBookmark_btn');
    if (favoriteBookmarkBtn) favoriteBookmarkBtn.addEventListener('click', refreshFavoriteBookmark);

    const successBtn = document.querySelector('.success_btn');
    if (successBtn) successBtn.addEventListener('click', refreshSuccess);

    // Interactive elements
    const myListCTA = document.querySelector('.myListCTA');
    if (myListCTA) myListCTA.addEventListener('click', myListToggle);

    const favoriteCTA = document.querySelector('.favoriteCTA');
    if (favoriteCTA) favoriteCTA.addEventListener('click', favoriteToggle);

    const favoriteBookmark = document.querySelector('.favoriteBookmark');
    if (favoriteBookmark) favoriteBookmark.addEventListener('click', bookmarkToggle);
});